import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { ResultProvider, ResultListModel } from '../../../../providers/result/result';
import { UserProvider, PrivateProfile, MySportProfileListItem, PublicProfileModel } from '../../../../providers/user/user';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { ValueProvider } from '../../../../providers/value/value';
import { ResultProfilePage } from '../../result-profile/result-profile';
import { EventProvider, EventDetailsModel } from '../../../../providers/event/event';
import { EventTabsPage } from '../../../event/details/event-tabs/event-tabs';
import { providerDef } from '@angular/core/src/view';
import { ResultMenuToolbarComponent } from '../../../../components/result-menu-toolbar/result-menu-toolbar';
import { LoginPage } from '../../../login/login/login';
import { SessionProvider } from '../../../../providers/session/session';

@Component({
    selector: 'page-result-details-comment',
    templateUrl: 'result-details-comment.html'
})
export class ResultDetailsCommentPage {

    ionInputNgModel: any = "";
    comments: any;
    result: ResultListModel;
    friends: MySportProfileListItem[];
    profile: PrivateProfile;

    friendsList = new Array();
    myCommentList = new Array();

    pager: { page: any, start: any, limit: any } = { page: null, start: null, limit: null };

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public app: App,
        public translate: TranslateService,
        private resultProvider: ResultProvider,
        private userProvider: UserProvider,
        private loadingCtrl: LoaderProvider,
        private sessionService: SessionProvider,
        private valueService: ValueProvider,
        private userService: UserProvider,
        private eventService: EventProvider
    ) {
    }

    // isFriend(spid) {
    //     console.log(spid);
    //     if (this.friends !== undefined) return ((this.friends.findIndex(f => f.id == spid)) > -1) ? true : false;
    // }

    isOwner(spid) {
        console.log(spid);
        console.log(this.profile);
        if (this.profile !== undefined) return (spid == this.profile.id) ? true : false;
    }

    onDeleteComment(spid, id) {
        if (!this.sessionService.isLoged) {
            this.navCtrl.push(LoginPage, { isRootNav: false });
            return;
        }

        this.resultProvider.deleteComment(spid, this.result.id).then(data => {
            this.myCommentList[id] = false;
            this.getComments();
        })
    }

    onAddComment() {
        if (this.ionInputNgModel.length == 0) return;
        if (!this.sessionService.isLoged) {
            this.navCtrl.push(LoginPage, { isRootNav: false });
            return;
        }

        console.log('this.ionInputNgModel: ', this.ionInputNgModel);
        this.resultProvider.addComment(this.result.id, this.ionInputNgModel).then(data => {
            console.log('data: ', data);
            this.getComments();
        });
    }


    getComments(): Promise<any> {
        if (!this.result) {
            return;
        }
        return new Promise<any>((resolve, reject) => {
            this.resultProvider.getComments(this.result.id, this.pager.page, this.pager.start, this.pager.limit).then(data => {
                this.comments = data;
                console.log('this.comments: ', this.comments);
                this.updateMyCommentList();
                resolve(data);
            });
        });
    }

    onAddFriend(comment, id) {
        this.userProvider.addFriend(comment.usrId).then(() => {
            this.friendsList[id] = true;
        });
    }

    onRemoveFriend(comment, id) {
        this.userProvider.removeFriend(comment.usrId).then(() => {
            this.friendsList[id] = false;
        });
    }

    getPrivateProfile(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!this.sessionService.isLoged) { resolve(null); return; }
            this.userProvider.getPrivateProfile().then(profile => {
                this.profile = profile;
                resolve(profile);
            }).catch(err => {
                console.log('err: ', err);
                reject();
            });
        });
    }

    getFriends(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!this.sessionService.isLoged) resolve([]);
            else this.userProvider.getMyFriends().then((friends: MySportProfileListItem[]) => {
                console.log('friends: ', friends);
                this.friends = Object.assign([], friends);
                resolve(friends);
            });
        });
    }

    getProfileImageDOM(spid) {
        this.userProvider.getUserPic(spid).then(image => image);
    }

    onCommentPressed(isFirst: boolean) {
        (isFirst) ? this.openEventDetails() : this.showSportProfile();
    }

    openEventDetails() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getEventDetails(this.result.eventId).then((event: EventDetailsModel) => {

            if (event.name.length < 1) {
                this.openEventDetails();
                loader.dismiss();
            } else {
                (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
            }
        });
    }

    showSportProfile() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
    }

    ionViewWillEnter() {
        console.log('ionViewWillEnter: ');
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.result = this.navParams.get('result');

        if (!this.result) {
            loader.dismiss();
            return;
        }

        Promise.all([this.getPrivateProfile(), this.getFriends(), this.getComments()]).then((data) => {
            let prof = data[0];
            let friends: any[] = data[1];
            let comments: any[] = data[2];

            this.friendsList = new Array(comments.length).fill(false);
            this.myCommentList = new Array(comments.length).fill(false);

            if (!prof) {
                loader.dismiss();
                return;
            }

            for (let i = 0; i < friends.length; i++) {
                for (let j = 0; j < comments.length; j++) {
                    if (comments[j].usrId == friends[i].id) {
                        this.friendsList[j] = true;
                    }
                    if (prof.id == comments[j].usrId) {
                        this.myCommentList[j] = true;
                    }
                }
            }
            console.log('this.friendsList: ', this.friendsList);

            loader.dismiss();
        });
    }

    updateMyCommentList() {
        if (!this.profile) return;
        this.myCommentList = new Array(this.comments.length).fill(false);
        for (let j = 0; j < this.comments.length; j++) {
            if (this.profile.id === this.comments[j].usrId) {
                this.myCommentList[j] = true;
                console.log('this.myCommentList: ', this.myCommentList);
            }
        }
    }
}


// WEBPACK FOOTER //
// /src/pages/results/result-details/result-details-comment/result-details-comment.ts